import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

function Singpass() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const lastPath = sessionStorage.getItem('lastPath')
    const code = searchParams.get('code')
    const state = searchParams.get('state')
    const error = searchParams.get('error')
    const errorDesc = searchParams.get('error-description')

    if (lastPath) {
      navigate(lastPath, {
        state: {
          code: code,
          state: state,
          error: error,
          errorDesc: errorDesc,
        },
      })
    }
  }, [navigate, searchParams])

  return null
}

export default Singpass
